import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Edit, Trash2 } from "react-feather";
import Table from "../../core/pagination/datatable";
import PageHeader from "../components/PageHeader";
import confirmDelete from "../components/confirmDelete";
import PatientModal from "../../core/modals/patients/PatientModal";
import { fetchPatients, deletePatientThunk } from "../../core/redux/slices/patientSlice";

const PatientList = () => {
  const dispatch = useDispatch();
  const { list, loading } = useSelector((s) => s.patients);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editRecord, setEditRecord] = useState(null);

  useEffect(() => { dispatch(fetchPatients()); }, [dispatch]);

  const data = useMemo(() => {
    const q = search.toLowerCase();
    return list.filter((p) =>
      !q || p.patientName?.toLowerCase().includes(q) || p.mobileNumber?.includes(q) || p.opNumber?.includes(q)
    );
  }, [list, search]);

  const openAdd = () => { setEditRecord(null); setShowModal(true); };
  const openEdit = (rec) => { setEditRecord(rec); setShowModal(true); };
  const closeModal = () => { setShowModal(false); setEditRecord(null); dispatch(fetchPatients()); };

  const handleDelete = (rec) =>
    confirmDelete(() => dispatch(deletePatientThunk(rec.id)), rec.patientName);

  const columns = [
    { title: "OP No", dataIndex: "opNumber", sorter: (a, b) => (a.opNumber || "").localeCompare(b.opNumber || ""), width: 100 },
    { title: "Patient Name", dataIndex: "patientName", sorter: (a, b) => a.patientName.localeCompare(b.patientName) },
    { title: "Mobile", dataIndex: "mobileNumber" },
    { title: "DOB", dataIndex: "dob", render: (v) => v ? new Date(v).toLocaleDateString("en-IN") : "—" },
    { title: "Age", dataIndex: "age", width: 60 },
    { title: "Gender", dataIndex: "gender", width: 80 },
    { title: "Category", dataIndex: "category", width: 90,
      render: (v) => <span className={`badge bg-${v === "Arab" ? "warning" : v === "Custom" ? "info" : "success"} text-white`}>{v || "Normal"}</span> },
    {
      title: "Action", dataIndex: "action", width: 100,
      render: (_, rec) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <button className="me-2 p-2 btn btn-sm btn-icon" onClick={() => openEdit(rec)} title="Edit">
              <Edit size={15} className="feather-edit" />
            </button>
            <button className="p-2 btn btn-sm btn-icon text-danger" onClick={() => handleDelete(rec)} title="Delete">
              <Trash2 size={15} className="feather-trash-2" />
            </button>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <PageHeader title="Patients" subtitle="Manage patient records" onAdd={openAdd} addLabel="Add Patient" />
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input type="text" placeholder="Search by name, mobile, OP No..."
                    className="form-control form-control-sm formsearch"
                    value={search} onChange={(e) => setSearch(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <Table columns={columns} dataSource={data} loading={loading} />
            </div>
          </div>
        </div>
      </div>
      <PatientModal show={showModal} onClose={closeModal} editRecord={editRecord} />
    </div>
  );
};

export default PatientList;
